import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'app/services/app.settings.service';
import { Observable } from 'rxjs';
import { BaseResultModel, SearchCriteriaModel, SearchResult } from 'app/models';
import { AccountCategorySearchCriteriaModel } from '../models/account-categories-search-criteria.model';
import { AccountCategoryModel } from '../models/account-categories.model';
import { map, shareReplay } from 'rxjs/operators';
import { DropDownItem } from 'app/models/general/dropdownItem.model';

@Injectable()
export class AccountCategoryService {

    private readonly _apiUri: string;
    private readonly endpoint = '/api/accounting-category';
    private _cachedCategories$: Observable<DropDownItem[]>;

    constructor(private http: HttpClient, configService: AppConfigService) {
        if (configService) {
            this._apiUri = configService.getAPIUrl();
        }
    }

    searchAccountCategories(model: SearchCriteriaModel<AccountCategorySearchCriteriaModel>): Observable<BaseResultModel<SearchResult<AccountCategoryModel>>> {
        return this.http.post<BaseResultModel<SearchResult<AccountCategoryModel>>>(`${this._apiUri}${this.endpoint}/search`, model);
    }

    createAccountCategory(request: any): Observable<BaseResultModel<number>> {
        return this.http.post<BaseResultModel<number>>(`${this._apiUri}${this.endpoint}`, request);
    }

    updateAccountCategory(id: number, request: any): Observable<BaseResultModel<string>> {
        return this.http.put<BaseResultModel<string>>(`${this._apiUri}${this.endpoint}/${id}`, request);
    }

    deleteAccountCategory(id: number): Observable<BaseResultModel<string>> {
        return this.http.delete<BaseResultModel<string>>(`${this._apiUri}${this.endpoint}/${id}`);
    }

    batchDeleteAccountCategories(ids: number[]): Observable<BaseResultModel<number>> {
        return this.http.post<BaseResultModel<number>>(`${this._apiUri}${this.endpoint}/batch-delete`, { ids });
    }

    getRefAccountCategories(): Observable<DropDownItem[]> {
        if (!this._cachedCategories$) {
            this._cachedCategories$ = this.http.get<BaseResultModel<DropDownItem[]>>(
                `${this._apiUri}${this.endpoint}/dropdown`
            ).pipe(
                map(response => response.status ? response.response : []),
                shareReplay(1)
            );
        }
        return this._cachedCategories$;
    }
}
